module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"We look forward to your interview"}}')
  delete Component.options._Ctor
}
